<script>
import { required, email } from 'vuelidate/lib/validators'
import { customerMethods } from '@state/helpers'

export default {
  data() {
    return {
      emailReset: '',
      tryingToSendResetPassword: false,
      resetSuccess: null,
      resetError: null,
      unlockAcctError: null,
      wasValidated: false,
      SendAcctUnlockEmail: false,
    }
  },
  validations: {
    emailReset: {
      required,
      email,
    },
  },
  methods: {
    ...customerMethods,
    // checking for locked account while doing password reset from forgot password link
    checkLockedAccount() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.wasValidated = true
      } else {
        this.SendAcctUnlockEmail = true
        return this.updateLockedAccountPassword(this.emailReset)
          .then(() => {
            this.$ga.event(
              'event',
              'Links',
              'ForgotPassword',
              'Forgot Password link'
            )

            this.$gtag.event('forgot_password', {})

            this.SendAcctUnlockEmail = false
          })
          .catch((error) => {
            this.SendAcctUnlockEmail = false
            this.unlockAcctError = error
          })
      }
    },
    // send reset password email from forgot password link
    trySendResetPassword() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.wasValidated = true
      } else {
        this.tryingToSendResetPassword = true
        return this.forgotPassword(this.emailReset)
          .then(() => {
            if (this.$ga) {
              this.$ga.event(
                'event',
                'Links',
                'ForgotPassword',
                'Forgot Password link'
              )
            }
            if (this.$gtag) {
              this.$gtag.event('forgot_password', {})
            }
            this.tryingToSendResetPassword = false
            this.resetSuccess =
              'Success! Please check your email for details on how to create a new password to access your AutoCheck account.'
          })
          .catch((error) => {
            this.tryingToSendResetPassword = false
            // check for locked account and display alert if it is locked
            if (
              error ===
              'Account is locked after 5 unsuccessful attempts. Password reset email will be sent.'
            ) {
              error =
                'Your account has been locked after max attempts for security reasons. Please check your email for unlocking account.'
              this.checkLockedAccount()
            }
            this.resetError = error
          })
      }
    },
    showModal() {
      this.$refs.myModalRef.show()
    },
    hideModal() {
      this.clearForm()
      this.$refs.myModalRef.hide()
    },
    clearForm() {
      this.emailReset = ''
      this.tryingToSendResetPassword = false
      this.resetSuccess = null
      this.resetError = null
      this.unlockAcctError = null
      this.wasValidated = false
    },
  },
}
</script>

<template>
  <form
    :class="{ 'was-validated ': wasValidated }"
    class="needs-validation"
    novalidate
    @submit.prevent="trySendResetPassword"
  >
    <span class="clickLink" :class="$style.forgotLink" @click="showModal">
      Unable to Sign in? Reset Your Password »
    </span>
    <b-modal
      ref="myModalRef"
      hide-footer
      centered
      title="Unable to Sign in? Reset Your Password"
      @hide="clearForm"
    >
      <div class="d-block">
        <b-alert v-if="resetSuccess" variant="success" show dismissible>
          {{ resetSuccess }}
        </b-alert>
        <b-alert v-if="resetError" variant="danger" show dismissible>
          {{ resetError }}
        </b-alert>
        <p
          >Enter the e-mail address associated with your AutoCheck.com account,
          then click Send. We'll email you a link to a page where you can easily
          create a new password.</p
        >
        <p
          ><strong
            >For security purposes, accounts that have not been accessed for
            over four months have been removed. Please create a new
            account.</strong
          ></p
        >
        <BaseInput
          v-model="$v.emailReset.$model"
          name="email"
          label="E-mail"
          :has-error="$v.emailReset.$error && wasValidated"
        >
          <div v-if="!$v.emailReset.required" class="invalid-feedback"
            >Field is required</div
          >
          <div v-if="!$v.emailReset.email" class="invalid-feedback"
            >Please enter a valid email address</div
          >
        </BaseInput>
      </div>
      <div class="d-flex">
        <BaseButton :disabled="tryingToSendResetPassword" type="submit">
          <BaseIcon v-if="tryingToSendResetPassword" name="sync" spin />
          <span v-else>
            Send
          </span>
        </BaseButton>
        <span class="clickLink" @click="hideModal">Cancel »</span>
      </div>
    </b-modal>
  </form>
</template>

<style lang="scss" module>
@import '@design';

.forgotLink {
  position: absolute;
  left: 130px;
  margin-top: -45px;
}
</style>
